module.exports = __webpack_public_path__ + "img/fondo.aef2bf5e.png";